<template>
    <form @submit.prevent="validarFormulario()" data-vv-scope="general" class="padding-content">

        <div class="padding-content table-components-temporary shadow-sm bg-gray-50">
        <b-row>
            <b-col>
                <!-- Nombre -->
                <b-form-group>
                    <label for="nombre"
                        >Nombre <span class="text-danger">(*)</span> :</label
                    >
                    <el-input
                        id="nombre"
                        name="nombre"
                        type="textarea"
                        class="uppercase"
                        rows="2"
                        v-model="producto.nombre"
                        data-vv-as=" "
                        v-validate="'required|min:1|max:1000'"
                    />
                    <span class="text-danger span-error small">{{
                        errors.first("general.nombre")
                    }}</span>
                </b-form-group>

                <!-- Sinonimos -->
                <b-form-group>
                    <label for="sinonimos"
                        >Sinonimos <span class="text-danger">(*)</span> :</label
                    >
                    <el-input
                        id="sinonimos"
                        name="sinonimos"
                        type="textarea"
                        class="uppercase"
                        rows="3"
                        v-model="producto.sinonimos"
                        data-vv-as=" "
                        v-validate="'required|min:1|max:1000'"
                    />
                    <span class="text-danger span-error small">{{
                        errors.first("general.sinonimos")
                    }}</span>
                </b-form-group>

                <b-row>
                    <!-- CAS -->
                    <b-col>
                        <b-form-group>
                            <label for="cas"
                                >CAS <span class="text-danger">(*)</span> :</label
                            >
                            <b-form-input
                                id="cas"
                                name="cas"
                                class="uppercase"
                                v-model="producto.cas"
                                data-vv-as=" "
                                v-validate="'required|min:1|max:1000'"
                            />
                            <span class="text-danger span-error small">{{
                                errors.first("general.cas")
                            }}</span>
                        </b-form-group>
                    </b-col>

                    <!-- Estado -->
                    <b-col>
                        <b-form-group>
                            <label for="estado"
                                >Estado <span class="text-danger">(*)</span> :</label
                            >
                            <el-select
                                id="estado"
                                name="estado"
                                v-model="producto.estado"
                                data-vv-as=" "
                                v-validate="'required'"
                            >
                                <el-option
                                    v-for="estado in estados"
                                    :key="estado.value"
                                    :label="estado.text"
                                    :value="estado.value"
                                />
                            </el-select>
                            <span class="text-danger span-error small">{{
                                errors.first("general.estado")
                            }}</span>
                        </b-form-group>
                    </b-col>

                    <!-- Fabricante -->
                    <b-col>
                        <b-form-group>
                            <label for="id_fabricante"
                                >Fabricante <span class="text-danger">(*)</span> :</label
                            >
                            <el-select
                                id="id_fabricante"
                                name="id_fabricante"
                                v-model="producto.id_fabricante"
                                filterable
                                no-data-text="No hay datos que coincidan"
                                no-match-text="No hay datos que coincidan"
                                @focus="listarFabricantes()"
                                data-vv-as=" "
                                v-validate="'required'"
                            >
                                <el-option
                                    v-for="fabricante in fabricantes"
                                    :key="fabricante.id"
                                    :label="fabricante.nombre"
                                    :value="fabricante.id"
                                />
                            </el-select>
                            <span class="text-danger span-error small">{{
                                errors.first("general.id_fabricante")
                            }}</span>
                        </b-form-group>
                    </b-col>
                    <!--Tipo Producto-->
                    <b-col>
                        <b-form-group>
                            <label for="">Tipo producto <span class="text-danger">(*)</span> : </label>
                            <el-select
                                id="tipoproducto"
                                name="tipoproducto"
                                v-model="producto.tipoproducto"
                                @focus="filtroTipoProducto"
                                data-vv-as=" "
                                v-validate="'required'"
                            >
                                <el-option
                                    v-for="item in tipoProductos"
                                    :key="item.id"
                                    :label="item.lista"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                            <span class="text-danger span-error small">{{
                                errors.first("general.tipoproducto")
                            }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Uso -->
                <b-form-group>
                    <label for="uso">Uso:</label>
                    <el-input
                        id="uso"
                        name="uso"
                        type="textarea"
                        class="uppercase"
                        v-model="producto.uso"
                        :rows="3"
                        data-vv-as=" "
                        v-validate="'min:1|max:1000'"
                    />
                    <span class="text-danger span-error small">{{
                        errors.first("general.uso")
                    }}</span>
                </b-form-group>

                <!-- Observación -->
                <b-form-group>
                    <label for="observacion">Observación:</label>
                    <el-input
                        id="observacion"
                        name="observacion"
                        type="textarea"
                        class="uppercase"
                        v-model="producto.observacion"
                        :rows="3"
                        data-vv-as=" "
                        v-validate="'min:1|max:1000'"
                    />
                    <span class="text-danger span-error small">{{
                        errors.first("general.observacion")
                    }}</span>
                </b-form-group>

                <!-- Disposición y tratamiento -->
                <b-form-group>
                    <label for="disposiciontratamiento">Disposición y tratamiento:</label>
                    <el-input
                        id="disposiciontratamiento"
                        name="disposiciontratamiento"
                        type="textarea"
                        class="uppercase"
                        v-model="producto.disposiciontratamiento"
                        :rows="3"
                        data-vv-as=" "
                        v-validate="'min:1|max:1000'"
                    />
                    <span class="text-danger span-error small">{{
                        errors.first("general.disposiciontratamiento")
                    }}</span>
                </b-form-group>
            </b-col>
        </b-row>
        </div>

        <br />
        <b-row>
            <b-col>
                <button class="btn btn-primary float-right" @click="validarFormulario()">
                    Siguiente
                </button>
                <button
                    class="btn btn-secondary float-right mr-2"
                    @click="setModalVer(false)"
                >
                    Cancelar
                </button>
            </b-col>
        </b-row>
    </form>
</template>

<script>
import Vue from "vue";

import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";

Vue.use(VeeValidate, {
    fieldsBagName: "vvFields",
    events: "change",
});

Validator.localize("es", es);
import { mapState, mapActions, mapMutations } from "vuex";

export default {
    name: "general",
    computed: {
        ...mapState("pasoapaso", ["producto", "fabricantes", "estados", "existe","tipoProductos"]),
    },
    methods: {
        async filtroTipoProducto() {
            if (!this.tipoProductos.length) {
                await this.cargarTipoProducto();
            }
        },
        ...mapActions("pasoapaso", ["listarFabricantes","cargarTipoProducto"]),
        ...mapMutations("pasoapaso", ["setModalPaso", "setModalVer"]),
        validarFormulario() {
            this.$validator.validateAll("general").then((result) => {
                if (result) {
                    this.setModalPaso(1);
                }
            });
        },
    },
};
</script>

<style>

.padding-content{
    padding: 20px;
}

.uppercase {
    text-transform: uppercase !important;
}

.uppercase textarea {
    text-transform: uppercase !important;
}
</style>
